<template>
  <div class="public-confirm-decline">
    <div class="public-confirm-decline__title">
      {{ $t('Your company') }} {{ contractorName }}
      {{ $t('is invited to participate in the tender') }}
    </div>
    <div class="public-confirm-decline__actions spacex-8">
      <Button icon="check-circle" @click.native="signUp">
        {{ $t('Confirm participation') }}
      </Button>
      <Button type="secondary" icon="x-circle" class="desktop-show" @click.native="signUp">
        {{ $t('Decline participation') }}
      </Button>
      <Button type="secondary" icon="x-circle" class="mobile-show" @click.native="signUp">
        {{ $t('Decline') }}
      </Button>
    </div>
  </div>
</template>

<script>
  import Button from '@/components/ui-v2/Button';
  export default {
    name: 'ConfirmDeclineOfPublicTender',
    components: { Button },
    props: {
      contractorName: {
        type: String,
        required: true,
      },
    },
    methods: {
      async signUp() {
        await this.$router.push({
          name: 'login',
        });
      },
    },
  };
</script>
<style scoped lang="scss">
  @import 'src/styles/pages/public-tender';
</style>
